/**
 * Plain CSV export: no dependency, quoting per RFC 4180. A cell is quoted only
 * when it has to be — it holds a comma, a quote or a line break.
 */

const escapeCell = (value) => {
  const text = value == null ? '' : String(value)
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

/** `columns` is `[{ header, value: (row) => any }]`, in output order. */
export const toCsv = (rows, columns) => {
  const header = columns.map((column) => escapeCell(column.header)).join(',')
  const body = rows.map((row) => columns.map((column) => escapeCell(column.value(row))).join(','))
  return [header, ...body].join('\r\n')
}

/** Save a Blob to disk under `filename` — the one DOM dance, shared. */
export const downloadBlob = (filename, blob) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

/** The BOM makes Excel read the file as UTF-8 rather than the system code page. */
export const downloadCsv = (filename, csv) => {
  downloadBlob(filename, new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' }))
}

/** Pull the filename out of a `Content-Disposition` header, or null. */
export const filenameFromDisposition = (disposition) => {
  if (!disposition) return null
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
  return match ? decodeURIComponent(match[1]) : null
}
